var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", {
    staticClass: "form-error is-visible margin-0 pega-pre-wrap",
    attrs: { "data-test": "label" },
    domProps: { textContent: _vm._s(_vm.label) },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }